// Read values from Vite environment variables (prefix with VITE_).

// Falls back to existing values when env vars are not provided.

import { env } from "../../config/env";

export const API_URL = env.IMAGE_ENDPOINT_URL;
export const API_KEY_EN = env.IMAGE_ENDPOINT_KEY;
export const API_URL_CMP = env.API_ENDPOINT_URL;
export const API_KEY_CMP = env.API_ENDPOINT_KEY;

/**
 * Security Implementation for Role-Based Access Control
 * 
 * URL Parameter Security:
 * - type=client: Users get 'family' role (restricted view, cannot toggle client view)
 * - type=staff: Users get 'staff' role (full access, can toggle between client and staff views)
 * - Any other value or missing parameter: Defaults to 'family' role for security
 * 
 * This ensures that:
 * 1. Clients can only see what they're supposed to see
 * 2. Staff members have additional privileges when accessing with type=staff
 * 3. Unknown or malicious URL parameters default to the most restrictive role
 */

export const encryptedCustomerId = () => {
  // Resolution order:
  // 3. URL query parameters (e.g. ?encryptedCustomerId=...)
  // 3 & 4) Only available in browser runtime
  if (typeof window !== 'undefined') {
    try {
      const params = new URLSearchParams(window.location.search);
      const paramKeys = ['cid', 'encryptedCustomerId', 'encryptedCustomerId', 'encrypted_customer_id', 'encCustomerId', 'customerId'];
      for (const k of paramKeys) {
        const v = params.get(k);
        if (v) return v;
      }

      // search for input/textarea elements with likely names/ids
      const selectors = [
        'input[name="encryptedCustomerId"]',
        'input[name="encryptedCustomerId"]',
        'input[name="encrypted_customer_id"]',
        'input[id="encryptedCustomerId"]',
        'textarea[name="encryptedCustomerId"]',
        'input[name="VITE_ENCRYPTED_CUSTOMER_ID"]'
      ];
      for (const s of selectors) {
        const el = document.querySelector<HTMLInputElement | HTMLTextAreaElement>(s);
        if (el && el.value) return el.value;
      }

      // finally, inspect forms for inputs matching the name
      for (const f of Array.from(document.forms)) {
        const found = f.querySelector<HTMLInputElement>('input[name="encryptedCustomerId"], input[name="encryptedCustomerId"], input[name="encrypted_customer_id"]');
        if (found && found.value) return found.value;
      }
    } catch (e) {
      // ignore
    }
  }

  return null;
}

export const getRcUserRole = () => {
  // Possible roles: 'staff', 'family', 'admin', null
  // Get role dynamically from URL parameter 'type'
  if (typeof window !== 'undefined') {
    try {
      const params = new URLSearchParams(window.location.search);
      const type = params.get('type');
      
      console.log(type);
      // Security: Map URL type parameter to internal roles
      switch (type) {
        case 'staff':
          return 'staff' as 'staff' | 'family' | 'admin' | null;
        case 'client':
        default:
          // Default to family role for client view and any other values
          return 'family' as 'staff' | 'family' | 'admin' | null;
      }
    } catch (e) {
      // If there's an error reading URL params, default to family role
      console.warn('Error reading URL parameters for user role:', e);
    }
  }
  
  // Fallback to family role if not in browser environment
  return 'family' as 'staff' | 'family' | 'admin' | null;
}

// Utility function to check if user has staff privileges
export const hasStaffPrivileges = () => {
  const role = getRcUserRole();
  return role === 'staff' || role === 'admin';
}

// Utility function to check if user can toggle client view
export const canToggleClientView = () => {
  return hasStaffPrivileges();
}

// Utility function to get the raw type parameter from URL (for debugging)
export const getUserTypeFromUrl = () => {
  if (typeof window !== 'undefined') {
    try {
      const params = new URLSearchParams(window.location.search);
      return params.get('type');
    } catch (e) {
      console.warn('Error reading type parameter from URL:', e);
    }
  }
  return null;
}

// Centre List
export const CentreList = [
  {
    id: 0,
    centreName: "Unassigned",
    label: "Unassigned",
    value: 0,
    isDisabled: false
  },
  {
    id: 1,
    centreName: "TM Gasing 136",
    label: "TM Gasing 136",
    value: 1,
    isDisabled: false
  },
  {
    id: 2,
    centreName: "TM Sri Aman",
    label: "TM Sri Aman",
    value: 2,
    isDisabled: false
  },
  {
    id: 3,
    centreName: "TM Gasing 60",
    label: "TM Gasing 60",
    value: 3,
    isDisabled: false
  },
  {
    id: 4,
    centreName: "Komune Care",
    label: "Komune Care",
    value: 4,
    isDisabled: false
  },
  {
    id: 5,
    centreName: "TPR Penang",
    label: "TPR Penang",
    value: 5,
    isDisabled: false
  },
  {
    id: 6,
    centreName: "HomeCare",
    label: "HomeCare",
    value: 6,
    isDisabled: false
  },
  {
    id: 7,
    centreName: "TM Ritchie",
    label: "TM Ritchie",
    value: 7,
    isDisabled: false
  },
  {
    id: 8,
    centreName: "Demo Company (Xero Development)",
    label: "Demo Company (Xero Development)",
    value: 8,
    isDisabled: false
  },
  {
    id: 9,
    centreName: "Angsana Home",
    label: "Angsana Home",
    value: 9,
    isDisabled: false
  },
  {
    id: 10,
    centreName: "Ara Woods",
    label: "Ara Woods",
    value: 10,
    isDisabled: false
  },
  {
    id: 11,
    centreName: "Jaya One Daycare",
    label: "Jaya One Daycare",
    value: 11,
    isDisabled: false
  },
  {
    id: 12,
    centreName: "Academy Care",
    label: "Academy Care",
    value: 12,
    isDisabled: false
  },
  {
    id: 13,
    centreName: "Care Collective",
    label: "Care Collective",
    value: 13,
    isDisabled: false
  },
  {
    id: 14,
    centreName: "Care Lux (Oakwood project)",
    label: "Care Lux (Oakwood project)",
    value: 14,
    isDisabled: false
  },
  {
    id: 15,
    centreName: "AmpangPuri",
    label: "AmpangPuri",
    value: 15,
    isDisabled: false
  }
];